import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup, TableWrapper } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Table, Button, Input, Space } from 'antd';
import { isEmpty } from 'utils/utils';
import { useTableInfo, useProjectAskSelectList } from 'hooks';
import { RefCode, PmCode,  } from 'components/TableSearchBox';
import { ColumnsType } from 'antd/lib/table/interface';

export interface ProjectAskSelectModalProps extends PopupProps {
    company_srl: number;
}

const ProjectAskSelectModal = ({ 
    isOpen, 
    onClose,
    company_srl}: ProjectAskSelectModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [pageNo, setPageNo] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [search, setSearch] = useState<string>('');
    const [pm, setPm] = useState<string>('');
    const [lectureType, setLectureType] = useState<string>();
    const [lectureSubject, setLectureSubject] = useState<string>();
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
    const [selectedRows, setSelectedRows] = useState<any>([]);

  const columns: ColumnsType<ProjectAskSelectListDto> = [
    {
      title: '번호',
      dataIndex: 'id',
      key: 'id',
      width: '70px',
      align: 'center',
    },  
    {
      title: '일자',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '100px',
      align: 'center',
      ellipsis: true,
      showSorterTooltip: false,
    },      
    {
      title: '고객사',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '150px',
      align: 'left', 
      ellipsis: true,  
    },  
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1',
      width: '120px',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1',
      width: '120px',
      align: 'center',
      ellipsis: true,
    },  
    {
      title: '요청사항',
      dataIndex: 'request_memo',
      key: 'request_memo',
      width: '250px',
      align: 'center',
      ellipsis: true,
    }, 
    {
      title: '기본대응',
      dataIndex: 'pm',
      key: 'pm',
      width: '70px',
      align: 'center',
      ellipsis: true,
    },     
    {
      title: 'F/U',
      dataIndex: 'pm2',
      key: 'pm2',
      width: '70px',
      align: 'center',
      ellipsis: true,
    }, 
  ];

  /* ======================================================
  * hooks
  * ====================================================== */
    const { askList, searchResult } = useProjectAskSelectList(company_srl, pageNo, pageSize, search, pm, lectureType, lectureSubject);  

   /* ======================================================
   * variables
   * ====================================================== */


   /* ======================================================
   * events
   * ====================================================== */
    const onSelect = () => {
        if (selectedRows.length > 0) {
            onClose?.(true, selectedRows[0].id, selectedRows[0].crm_srl)
        }
        
    };

   const onCancel = () => {
        onClose?.(false);
    };

   const onChangePageInfo = (pageNo: number, pageSize: number) => {
        setPageNo(pageNo);
        setPageSize(pageSize);
   };
   
  const rowSelection = {
    selectedRowKeys, // 선택된 행의 키 값 관리
    onChange: (newSelectedRowKeys, newSelectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(newSelectedRows); // 이 배열(newSelectedRows[0])에서 선택된 행의 데이터를 추출할 수 있습니다.
    },
  };

  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: pageNo || 1,
      pageSize: 10,
    },
    datas: askList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });    

  /* ======================================================
   * effects
   * ====================================================== */
 

    return (
    <>
        <ModalWrapper open={isOpen} onCancel={onCancel} width={1040} title={'문의 선택'} closable>
            <div style={{width:'100%'}}>
                <div className={'tableSearchBoxWrapper'}>
                    <Space>
                        <PmCode codeValue={(pm && pm !== 'A')?Number(pm):undefined} onChangeSelect={(value)=>{setPm(value.toString()); setPageNo(1)}} />                
                        <RefCode codeValue={lectureSubject} fieldName={'lecture_subject1'} placeholder={'강의주제'} onChangeSelect={(value)=>{setLectureSubject(value.toString()); setPageNo(1)}} />
                        <RefCode codeValue={lectureType} fieldName={'lecture_type1'} placeholder={'강의구분'} onChangeSelect={(value)=>{setLectureType(value.toString()); setPageNo(1)}} />
                        <Input.Search
                            className={'searchInput'}
                            value={search}
                            placeholder="담당자명을 입력하세요"
                            onSearch={(value)=>{setSearch(value.toString()); setPageNo(1)}}
                            allowClear
                        />
                    </Space>      
                </div>            
            </div>
            <TableWrapper isSearch={true}>
              <Table
                tableLayout="fixed"
                dataSource={askList}
                columns={columns}
                pagination={pagination}
                onChange={onTableChange}
                style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                className="columnCenterFixTable clickable"
                showSorterTooltip={false}
                rowKey={'id'}
                rowSelection={{type:'radio', ...rowSelection}}
                onRow={(record) => ({
                    onClick: () => {
                    // 행을 클릭했을 때 라디오 버튼이 선택되도록 처리
                    setSelectedRowKeys([record.id]);
                    setSelectedRows([record]);
                    },
                })}                
              />
            </TableWrapper>             
            <ButtonGroup className={'buttonsWrapper'}>
                <Button onClick={onCancel} style={{marginRight: "5px"}}>취소</Button> 
                <Button onClick={onSelect} type="primary">{'등록'}</Button>
            </ButtonGroup>             
        </ModalWrapper>  
    </>
    )    
};

export default React.memo(ProjectAskSelectModal);    